(() => {
  'use strict';
  if (window.ElternAnkerComposerAnalytics) return;
  window.ElternAnkerComposerAnalytics = true;

  const events = Object.freeze({
    design_start: 'ea_design_start',
    design_option: 'ea_design_option',
    design_review: 'ea_design_review',
    validation_error: 'ea_design_error',
    add_to_cart: 'ea_design_cart_success'
  });
  const fields = new Set(['shape', 'body', 'motif', 'front', 'back', 'mode', 'quantity']);
  const errors = new Set(['name', 'phone', 'rights', 'design', 'quantity']);
  const testMode = new URLSearchParams(location.search).get('ea_test');
  const sentOnce = new Set();

  function diagnose(status) {
    if (!['internal', 'debug'].includes(testMode)) return;
    try {
      console.info('[ElternAnker analytics]', status);
    } catch {
      // Diagnostic output must not affect the shop.
    }
  }

  function allowed() {
    const privacy = window.Shopify?.customerPrivacy;
    if (typeof privacy?.analyticsProcessingAllowed !== 'function') {
      diagnose('consent_api_missing');
      return false;
    }
    try {
      if (privacy.analyticsProcessingAllowed() === true) return true;
    } catch {
      // An unavailable permission check never implies consent.
    }
    diagnose('consent_not_allowed');
    return false;
  }

  function send(name, values = {}, once = false) {
    if ((once && sentOnce.has(name)) || !allowed()) return;
    if (!Array.isArray(window.dataLayer)) {
      diagnose('queue_missing');
      return;
    }
    const params = {
      send_to: 'G-866WKM23H4',
      page_location: location.origin + location.pathname,
      page_title: 'ElternAnker gestalten',
      ...values
    };
    if (['internal', 'debug'].includes(testMode)) params.debug_mode = true;
    if (testMode === 'internal') params.traffic_type = 'internal';
    try {
      // Reuse the installed tag; never configure another tag or send purchase.
      (function () { window.dataLayer.push(arguments); })('event', name, params);
      if (once) sentOnce.add(name);
      diagnose('queued');
    } catch {
      // Analytics must not interrupt configuration or cart handling.
    }
  }

  function view() {
    if (document.querySelector('[data-og-composer]')) send('ea_configurator_view', {}, true);
  }

  function initialize() {
    view();
    if (window.Shopify?.customerPrivacy || typeof window.Shopify?.loadFeatures !== 'function') return;
    try {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], error => {
        if (!error) view();
      });
    } catch {
      // Missing privacy support must fail closed, never imply consent.
    }
  }

  document.addEventListener('origin:composer', event => {
    const detail = event.detail;
    if (!event.target?.matches?.('[data-og-composer]') || !detail || !Object.hasOwn(events, detail.event)) return;
    view();
    const params = {};
    if (['online', 'offline'].includes(detail.contact_mode)) params.contact_mode = detail.contact_mode;
    if (Number.isInteger(detail.quantity) && detail.quantity >= 1 && detail.quantity <= 5) params.bundle_quantity = detail.quantity;
    if (['wolke', 'herz', 'stern', 'fussball'].includes(detail.shape)) params.shape = detail.shape;
    // A new permitted interaction can start measurement after earlier consent denial.
    send('ea_design_start', params, true);
    if (detail.event === 'design_option' && fields.has(detail.field)) params.option_field = detail.field;
    if (detail.event === 'validation_error' && errors.has(detail.field)) params.error_code = detail.field;
    if (detail.event !== 'design_start') send(events[detail.event], params);
  });

  document.addEventListener('DOMContentLoaded', initialize, { once: true });
  document.addEventListener('visitorConsentCollected', view);
  if (document.readyState !== 'loading') initialize();
})();
